import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XImage, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class ContactInfo extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ContactInfo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    let {info} = this.props;
    let {contactinfo} = info ?? {};
    let {phone, whatsapp, fax, email, address} = contactinfo ?? {};
    return (
      <VStack width={"48%"} HAlign="[" mR={28}>
        <VStack fullWidth spacing={24} HAlign="[">
          <HStack>
            <XText fullWidth textAlign="[" color={ColorX.CSS("Stone")} bold fontSize={16}>
              {LocaleX.Parse({
                EN: "Contact Information",
                TC: "聯絡資料"
              })}
            </XText>
          </HStack>
          <HStack spacing={5} HAlign="[" width={"auto"}>
            <XImage source="/Images/Icons/phonecom.png" 
              width={24} height={24} noResize/>
            <XText color={ColorX.CSS("Stone")}>{phone}</XText>
          </HStack>
          <HStack spacing={5} HAlign="[" width={"auto"}>
            <XImage source="/Images/Icons/whatsapp.png" 
              width={24} height={24} noResize/>
            <XText color={ColorX.CSS("Stone")}>{whatsapp}</XText>
          </HStack>
          <HStack spacing={5} HAlign="[" width={"auto"}>
            <XImage source="/Images/Icons/fax.png" 
              width={24} height={24} noResize/>
            <XText color={ColorX.CSS("Stone")}>{fax}</XText>
          </HStack>
          <HStack spacing={5} HAlign="[" width={"auto"}>
            <XImage source="/Images/Icons/email.png"
              width={24} height={24} noResize/>
            <XText color={ColorX.CSS("Stone")}>{email}</XText>
          </HStack>
          <HStack spacing={5} HAlign="[">
            <XImage source="/Images/Icons/location.png"
              width={24} height={24} noResize/>
            <XText color={ColorX.CSS("Stone")}>{LocaleX.Parse(address)}</XText>
          </HStack>
        </VStack>
      </VStack>
    );
  }

}

export default observer(ContactInfo);
